import React from "react";
import AprobacionSolicitudes from "./AprobacionSolicitudes/AprobacionSolicitudes";
import HistorialAprobaciones from "./HistorialAprobacionesSolicitudes/HistorialAprobaciones";
import PlanificacionVacaciones, { Props_PlanificacionVacaciones } from "./Vacaciones/PlanificacionVacaciones";
import RegistroEntradaSalida from "./RegistroEntradaSalida/RegistroEntradaSalida";
import AprobacionSolicitudesMarcacion from "./RegistroEntradaSalida/AprobacionSolicitudes";
import PersonalAprobar from "./RegistroEntradaSalida/PersonalAprobar/PersonalAprobar";
import PlanificacionHE from "./Horas Extras/PlanificacionHE/PlanificacionHE";
import ProyeccionHE from "./Horas Extras/ProyeccionHE/ProyeccionHE";
import ProyeccionHEInicio from "./Horas Extras/ProyeccionHE/ProyeccionHEInicio";
import PlanificacionHEInicio from "./Horas Extras/PlanificacionHE/PlanificacionHEInicio";
import HistorialPlanificacion from "./Horas Extras/Historial/HistorialPlanificacion";
import AsignacionPresupuestoGPE from "./Horas Extras/Asignacion Presupuesto/AsignacionPresupuestoGPE";

import ComunicadoSolicitudes from "./ComunicadoSolicitudes/ComunicadoSolicitudes";
import FirmaAPNomina from "../Admin/FirmaAPNomina/FirmaAPNomina";
import HistorialMarcaciones from "components/UsuarioGeneral/Registro Entrada Salida/HistorialMarcaciones";
import ProyectosInstitucionales from "./ProyectosInstitucionales/ProyectosInstitucionales";
import ProyectosInstitucionalesAutoridad from "./ProyectosInstitucionales/ProyectosInstitucionalesAutoridad";
import ProyectosInstitucionalesConsultor from "./ProyectosInstitucionales/ProyectosInstitucionalesConsultor";
import { DocumentoPagoEspolHE } from "../Admin/Horas Extras/Revision Documento Pago Horas Extras/DocumentosPagoESPOLHE";
import AprobacionSolicitudesHE from "./Horas Extras/Aprobacion Solicitudes/AprobacionSolicitudesHE";
import DashboarDirectivo from "./Horas Extras/PresupuestoDashboard";
import HistorialSolciitudesDUHE from "./Horas Extras/Historial/HistorialSolicitudes";
import ModificacionPresupuestoGPE from "./Horas Extras/Asignacion Presupuesto/ModificacionPresupuestoGPE";

import FirmaAvisoEntradaFinanciero from "./Firma Aviso Entrada Financiero/FirmaAvisoEntradaFinanciero";
import HistorialAvisoEntrada from "./Firma Aviso Entrada Financiero/Historial Firma Aviso Entrada/HistorialAvisoEntrada";
import FirmaAPVacaviones from "../Admin/FirmaAPVacaciones/FirmaAPVacaciones";
import ComunicadoSolicitudesV from "./ComunicadoVacaciones/ComunicadoSolicitudesV";
import HistorialModificacionPresupuesto from "./Horas Extras/Historial Modificacion Presupuesto/HistorialModificacionPresupuesto";
import ModificacionPresupuestoUnidad from "./Horas Extras/Modificación Presupuesto Unidad/ModificacionPresupuesto";
import HistorialDirectivoModificacionPHE from "./Horas Extras/Historial Modificacion Presupuesto/HistorialDirectivosModPHE";

// (props: { children?: ReactNode; }, context?: any): ReactElement<any, any>
const a = <div style={{ tableLayout: "fixed" }}></div>
const DIRECTIVOS_ROUTES: Array<{ path: string, component: any, layout: string }> = [
    // {
    //     path: "/administrar_planificacion/administrativo",
    //     component: PlanificacionVacaciones ,
    //     layout: "/directivo",
    //     render:true,
    //     component_render:<PlanificacionVacaciones tipo_personal={"PA"}/>
    // },
    // {
    //     path: "/administrar_planificacion/docente",
    //     component: PlanificacionVacaciones,
    //     layout: "/directivo",
    //     render:true,
    //     component_render:<PlanificacionVacaciones tipo_personal={"PD"}/>

    // },
    {
        path: "/aprobacionSolicitudes",
        component: AprobacionSolicitudes,
        layout: "/directivo"
    },
    {
        path: "/historialaprobacionSolicitudes",
        component: HistorialAprobaciones,
        layout: "/directivo"
    },
    {
        path: "/aprobacionSolicitudesMarcacion",
        component: AprobacionSolicitudesMarcacion,
        layout: "/directivo"
    },
    {
        path: "/historial_marcaciones",
        component: HistorialMarcaciones,
        layout: "/directivo",
    },
    {
        path: "/registroentradasalida",
        component: RegistroEntradaSalida,
        layout: "/directivo"
    },
    {
        path:"/marcacionesPersonal",
        component: PersonalAprobar,
        layout: "/directivo"
    },
   
    {
        path:"/proyeccionHorasExtras/asignacionpresupuesto",
        component: AsignacionPresupuestoGPE,
        layout: "/directivo"
    },
    {
       path:"/proyeccionHorasExtras/modificacionpresupuesto",
       component: ModificacionPresupuestoGPE,
       layout: "/directivo"
    },
    {
       path:"/proyeccionHorasExtras/historialmodpresupuesto",
       component: HistorialModificacionPresupuesto,
       layout: "/directivo"
    },
    {
        path:"/proyeccionHorasExtras/inicio",
        component: ProyeccionHEInicio,
        layout: "/directivo"
    },
    {
        path:"/proyeccionHorasExtras",
        component: ProyeccionHE,
        layout: "/directivo"
    },
    {
        path:"/historiaProyeccionHorasExtras",
        component: ProyeccionHE,
        layout: "/directivo"
    },
     {
        path:"/planificacionHorasExtras",
        component: PlanificacionHEInicio,
        layout: "/directivo"
    },
    {
        path:"/planificacionHorasExtrasMensual",
        component: PlanificacionHE,
        layout: "/directivo"
    },
    {
        path:"/historialplanificacionHorasExtras",
        component: HistorialPlanificacion,
        layout: "/directivo"
    },
    {
        path:"/aprobacionHorasExtras",
        component: AprobacionSolicitudesHE,
        layout: "/directivo"
    },
    {
        path: "/notificarSolicitudes",
        component: ComunicadoSolicitudes,
        layout: "/directivo"
    },
    {
        path: "/notificarVacacionesTh",
        component: ComunicadoSolicitudesV,
        layout: "/directivo"
    },
    {
        path: "/firmaAPNomina",
        component: FirmaAPNomina,
        layout: "/directivo",
    },
    {
        path: "/proyectosinstitucionales",
        component: ProyectosInstitucionales,
        layout: "/directivo"
    },
    {
        path: "/proyectosinstitucionalesautoridad",
        component: ProyectosInstitucionalesAutoridad,
        layout: "/directivo"
    },
    {
        path: "/proyectosinstitucionalesconsultor",
        component: ProyectosInstitucionalesConsultor,
        layout: "/directivo"
    },
    {
        path: "/firmadocumentopago",
        component: DocumentoPagoEspolHE,
        layout: "/directivo"
    },
    {
        path: "/PresupuestoDashBoard",
        component: DashboarDirectivo,
        layout: "/directivo"
    },
    // {
    //    path: "/solicitudmodificacionpresupuesto",
    //    component: ModificacionPresupuestoUnidad,
    //    layout: "/directivo"
    // },
    // {
    //     path: "/historialsolicitudesmodificacion",
    //    component: HistorialDirectivoModificacionPHE,
    //    layout: "/directivo"
    // },
    {
        path: "/HistorialSolicitudesHE",
        component: HistorialSolciitudesDUHE,
        layout: "/directivo"
    },
    {
        path: "/firmaAPVacaciones",
        component: FirmaAPVacaviones,
        layout: "/directivo",
    },
    {
        path: "/firmaAvisoEntrada",
        component: FirmaAvisoEntradaFinanciero,
        layout:"/directivo"
    },
    {
        path: "/historialFirmasAE",
        component: HistorialAvisoEntrada,
        layout: "/directivo"
    }
];
export default DIRECTIVOS_ROUTES;